import dayjs from 'dayjs';
import dayjsTimezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';

dayjs.extend(utc);
dayjs.extend(dayjsTimezone);

interface Props {
  timezone: string;
}

export function ProgressiveLiveClock({ timezone }: Props) {
  const [progressiveTime, setProgressiveTime] = useState(() => {
    const now = dayjs().tz(timezone);
    return {
      full: `${now.format('ddd HH:mm:ss, D-MMM-YY')} (${timezone})`,
      large: `${now.format('HH:mm:ss')} (${timezone})`,
      medium: `${now.format('HH:mm')} ${timezone}`,
      small: now.format('HH:mm'),
      minimal: now.format('HH:mm'),
    };
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = dayjs().tz(timezone);
      setProgressiveTime({
        full: `${now.format('ddd HH:mm:ss, D-MMM-YY')} (${timezone})`,
        large: `${now.format('HH:mm:ss')} (${timezone})`,
        medium: `${now.format('HH:mm')} ${timezone}`,
        small: now.format('HH:mm D/MM/YY'),
        minimal: now.format('HH:mm'),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timezone]);

  return (
    <>
      {/* @2xl+ */}
      <span className="@2xl:inline hidden">{progressiveTime.full}</span>
      {/* @xl */}
      <span className="@2xl:hidden @xl:inline hidden">
        {progressiveTime.large}
      </span>
      {/* @lg */}
      <span className="@xl:hidden @lg:inline hidden">
        {progressiveTime.medium}
      </span>
      {/* @md */}
      <span className="@lg:hidden @md:inline hidden">
        {progressiveTime.small}
      </span>
      {/* @sm and below */}
      <span className="@md:hidden">{progressiveTime.minimal}</span>
    </>
  );
}

export default ProgressiveLiveClock;
